import { useMemo } from 'react';
import { Route } from 'react-router-dom';
import { Back } from 'components/quashed';
import {
  POLICY_DETAILS_DOCS_ROUTE,
  RENEWAL_UPLOAD_ROUTE,
  RENEWAL_MANUAL_ROUTE,
} from 'constants/routes';
import RenewalUpdate, { RenewalUpdatePaths } from 'containers/renewal-update';
import history from 'helpers/history';
import PolicyRenewalContainer from '../PolicyRenewalContainer';
import PolicyDetailsDocs from './PolicyDetailsDocs';
import PolicyDetailsTitle from './PolicyDetailsTitle';
import styles from '../styles/PolicyDetailsContainer.module.scss';
import { getPolicyDetailsRoute } from 'helpers';

const RenewalMobile = ({
  path,
  policy,
  policyProvider,
  selectedRenewal,
  title,
}) => {
  return (
    <>
      {title}
      {selectedRenewal ? (
        <PolicyRenewalContainer
          hideTitle={true}
          policy={policy}
          policyProvider={policyProvider}
          selectedRenewal={selectedRenewal}
        />
      ) : (
        <RenewalUpdate
          defaultPath={path}
          policy={policy}
          prevButtonText="Previous"
          onPrevBtnClick={() => history.push(getPolicyDetailsRoute(policy.id))}
        />
      )}
    </>
  );
};

const PolicyDetailsMobile = ({
  policyScanId,
  employer,
  isOwner,
  policy,
  policyProvider,
  isReview,
  user,
  selectedRenewal,
  allowMarketScan,
  pendingRenewal,
}) => {
  const title = useMemo(
    () => (
      <PolicyDetailsTitle
        img={policyProvider?.logoUrl}
        policy={policy}
        policyProvider={null}
        allowMarketScan={allowMarketScan}
      />
    ),
    [policy, policyProvider?.logoUrl],
  );
  return (
    <>
      <Route path={POLICY_DETAILS_DOCS_ROUTE}>
        {title}
        <PolicyDetailsDocs
          disabled={isReview}
          employer={employer}
          hideTitle={true}
          isOwner={isOwner}
          showUploadBtn={isOwner}
          pendingRenewal={pendingRenewal}
          policy={policy}
          policyScanId={policyScanId}
          user={user}
        />
        <div className={styles.buttons}>
          <Back
            className={styles.back}
            link={getPolicyDetailsRoute(policy.id)}
          />
        </div>
      </Route>
      <Route path={RENEWAL_UPLOAD_ROUTE}>
        <RenewalMobile
          path={RenewalUpdatePaths.UPLOAD}
          policy={policy}
          policyProvider={policyProvider}
          selectedRenewal={selectedRenewal}
          title={title}
        />
      </Route>
      <Route path={RENEWAL_MANUAL_ROUTE}>
        <RenewalMobile
          path={RenewalUpdatePaths.MANUAL}
          policy={policy}
          policyProvider={policyProvider}
          selectedRenewal={selectedRenewal}
          title={title}
        />
      </Route>
    </>
  );
};

export default PolicyDetailsMobile;
